import * as React from 'react';
const EDGE_LENGTH = { large: 48, default: 24, small: 12 };
export const ExternalIcon = React.forwardRef((props, ref) => {
    const variant = props.variant || 'default';
    const ariaHidden = !props.alt;
    const edgeLength = EDGE_LENGTH[variant];
    const svgSelector = props.svgSelector === undefined ? '#main' : props.svgSelector;
    return (React.createElement("svg", { className: props.className, "aria-hidden": ariaHidden, role: ariaHidden ? undefined : 'img', "aria-label": props.alt || undefined, ref: ref, width: edgeLength, height: edgeLength, viewBox: `0 0 ${edgeLength} ${edgeLength}`, fill: "currentColor" },
        props.title && React.createElement("title", null, props.title),
        React.createElement("use", { href: `${props.url}${svgSelector}` })));
});
ExternalIcon.displayName = 'ExternalIcon';
ExternalIcon.defaultProps = {
    variant: 'default',
    svgSelector: '#main',
};
